<template>
  <div class="cycling-container hp-block-container">
    <h3 class="hp-block-title">How quickly can I get covered?</h3>
    <div class="cycling">
      <div class="block left">
        <div>We’ll cover you in under 60 seconds</div>
        <button
          class="button ps-button get-quote"
          @click="openQuickQuteModal()"
        >
          Get a quote
        </button>
      </div>

      <div class="img-container" />

      <div class="block right">
        <div>We’ll assess your claim within 24 hours</div>
        <nuxt-link to="/claim" class="button ps-button get-quote">
          Make a claim
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openQuickQuteModal() {
      this.$modal.show('quick-quote')
    },
  },
}
</script>

<style lang="scss" scoped>
.cycling-container {
  border-bottom: 1px solid $ps-gray;
}
.cycling {
  position: relative;
  min-height: 300px;
  @include tablet {
    min-height: 400px;
  }
  @include desktop {
    min-height: 400px;
  }
}
.img-container {
  background-image: url('~assets/images/illustrations/Speed.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 200px;
  @include tablet {
    position: absolute;
    width: 100%;
    height: 450px;
  }
}
.get-quote {
  // width: 70%;
  // height: 30px;
}
.block {
  color: $ps-gray;
  @include mobile {
    text-align: center;
    div {
      padding: 20px 0;
      font-size: 1.2rem;
      line-height: 1.2rem;
    }
  }
  @include tablet {
    position: absolute;
    top: 20px;
    width: 150px;
    font-size: 1.2rem;
    line-height: 1.2rem;
    z-index: 1;
    font-family: $family-regular;
    &.left {
      left: 30px;
    }
    &.right {
      right: 30px;
      text-align: right;
    }
    .button {
      margin-top: 20px;
    }
  }
  @include desktop {
    top: 40px;
    font-size: 1.5rem;
    line-height: 1.8rem;
    width: 166px;
  }
}
</style>
